import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="confirm-dialog-container">
      <h2 mat-dialog-title class="confirm-dialog-title">
        <mat-icon>warning</mat-icon>
        <span>{{ data.title }}</span>
      </h2>
      <mat-dialog-content class="confirm-dialog-content">
        <p class="confirm-dialog-message">{{ data.message }}</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end" class="confirm-dialog-actions">
        <button mat-button (click)="onCancel()">{{ data.cancelText || 'Отмена' }}</button>
        <button mat-raised-button color="primary" (click)="onConfirm()">
          {{ data.confirmText || 'Подтвердить' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .confirm-dialog-container {
      min-width: 400px;
      padding: 24px;
    }

    .confirm-dialog-title {
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
      margin: 0 0 20px 0 !important;
      padding: 0 !important;
      font-size: 20px !important;
      font-weight: 500 !important;
      color: #333 !important;
    }

    .confirm-dialog-title mat-icon {
      color: #ff9800 !important;
      font-size: 32px !important;
      width: 32px !important;
      height: 32px !important;
      flex-shrink: 0;
    }

    .confirm-dialog-content {
      padding: 0 !important;
      margin: 0 !important;
      overflow: visible !important;
      max-height: none !important;
    }

    .confirm-dialog-message {
      margin: 0 !important;
      font-size: 16px !important;
      line-height: 1.6 !important;
      color: #555 !important;
      padding: 0 !important;
    }

    .confirm-dialog-actions {
      padding: 24px 0 0 0 !important;
      margin: 0 !important;
      gap: 12px !important;
      min-height: auto !important;
    }

    .confirm-dialog-actions button {
      min-width: 110px !important;
    }
  `]
})
export class ConfirmDialogComponent {
  data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
